import React from 'react';
import { 
  FaGraduationCap,
  FaMapMarkerAlt,
  FaClock,
  FaEnvelope,
  FaPhone
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Admission Universitaire', link: '#services' },
    { name: 'Logement Étudiant', link: '#services' },
    { name: 'Visa Étudiant', link: '#services' },
    { name: 'Attestation AVI', link: '#services' }
  ];

  const quickLinks = [
    { name: 'À Propos', link: '#about' },
    { name: 'Services', link: '#services' },
    { name: 'Témoignages', link: '#testimonials' },
    { name: 'FAQ', link: '#faq' }
  ];

  return (
    <footer className="btg-footer-simple">
      <div className="btg-container">
        <div className="btg-footer-content">
          
          {/* Company Info */}
          <div className="btg-footer-section">
            <div className="btg-footer-logo">
              <div className="btg-logo-icon">
                <FaGraduationCap />
              </div>
              <div className="btg-logo-text">
                <span className="btg-logo-main">BTG CONSEIL</span>
                <span className="btg-logo-sub">Votre avenir en France</span>
              </div>
            </div>
            <p className="btg-footer-description">
              Votre partenaire de confiance pour réussir votre projet d'études en France.
            </p>
          </div>

          {/* Services */}
          <div className="btg-footer-section">
            <h3 className="btg-footer-title">Nos Services</h3>
            <ul className="btg-footer-links">
              {services.map((service, index) => (
                <li key={index}>
                  <a href={service.link} className="btg-footer-link">
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div className="btg-footer-section">
            <h3 className="btg-footer-title">Liens Rapides</h3>
            <ul className="btg-footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.link} className="btg-footer-link">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="btg-footer-section">
            <h3 className="btg-footer-title">Contactez-Nous</h3>
            <div className="btg-contact-info">
              <div className="btg-contact-item">
                <FaPhone className="btg-contact-icon" />
                <span>+33 7 63 70 50 88</span>
              </div>
              <div className="btg-contact-item">
                <FaEnvelope className="btg-contact-icon" />
                <span>pole.admin@btgconseil.com</span>
              </div>
              <div className="btg-contact-item">
                <FaMapMarkerAlt className="btg-contact-icon" />
                <span>Paris, France</span>
              </div>
              <div className="btg-contact-item">
                <FaClock className="btg-contact-icon" />
                <span>Lun - Ven: 9h - 18h</span>
              </div>
            </div>
          </div>

        </div>

        {/* Footer Bottom */}
        <div className="btg-footer-bottom">
          <div className="btg-footer-bottom-content">
            <div className="btg-copyright">
              <p>&copy; {currentYear} BTG CONSEIL. Tous droits réservés.</p>
            </div>
            <div className="btg-credits">
              <p>Réalisé par <a href="https://etef-design.fr/" target="_blank" rel="noopener noreferrer">etef design</a></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;